import Assinatura from './services/Assinatura'
import FormasDePagamento from './services/FormasDePagamento'
import Payment from './services/Payment'
import Plans from './services/Plans'
import Desconto from './services/Desconto'

export default {
  Assinatura,
  FormasDePagamento,
  Payment,
  Plans,
  Desconto
}
